
import React from 'react';

const ContentNotFound: React.FC = () => {
  return (
    <div className="flex-1 flex justify-center items-center">
      <p className="text-clustr-darkGray">Content not found</p>
    </div>
  );
};

export default ContentNotFound;
